import { render } from "./pc.vue?vue&type=template&id=06f9d935"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"

import "./pc.vue?vue&type=style&index=0&id=06f9d935&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__